import React from "react";
import { Row, Col, Container } from "react-bootstrap";
import { FaLinkedinIn } from "react-icons/fa";
import { IoMail } from "react-icons/io5";
import facebook from "../../images/Facebook (1).png"
import linkedin from "../../images/Linkedin.png"
import Youtube from "../../images/Youtube.png"
import Instagram from "../../images/Instagram.png"
import { useMediaQuery } from "react-responsive";
import logo from "../../images/Logo.png"
import { NavLink } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setformmodal } from "../../Components/Redux/Globalslice"
const Footer = () => {
    const dispatch = useDispatch()
    const { isMobile } = useMediaQuery({ query: '(max-width: 576px)' });
    const formmodal = useSelector((state) => state.Globalslice.formmodal);
    // console.log("formmodal", formmodal)
    const loginclick = () => {
        dispatch(setformmodal(!formmodal))

    }
    return (
        <div className="footer">

            <Container className="footermain globalbaody">
                <Row>
                    <Col lg={4}>
                        <div className="d-flex">
                            <div className="footerleft">
                                <img loading="lazy" className="footer-logo" src={logo} alt="logo"></img>
                                <div className="footer-titltes">
                                    Stay connected
                                </div>
                                <div className="footer-socials d-flex">
                                    <a
                                        href="https://www.linkedin.com/company/ai-medtech-alliance-foundation/about/"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        <FaLinkedinIn size={isMobile ? 30 : 40} className="footer-socialmedia" />
                                    </a>
                                    <a href={"mailto:contact@aimfoundation.ai"} onClick={(e) => e.stopPropagation()}>
                                        <IoMail size={isMobile ? 30 : 50} className="footer-socialmedia ps-2" />
                                    </a>
                                </div>
                                {/* <div className="d-flex">
                                <a href ="https://www.linkedin.com/company/ai-medtech-alliance-foundation/about/"
                                <FaLinkedinIn size={40} className="footer-socialmedia"/>
                                <IoMail size={40} className="footer-socialmedia"/>
                                mail to contact@aimfoundation.ai
                                {/* <img className="footer-socialmedia" src={facebook}></img>
                                <img className="footer-socialmedia" src={linkedin}></img>
                                <img className="footer-socialmedia" src={Instagram}></img>
                                <img className="footer-socialmedia" src={Youtube}></img> */}

                            </div>


                        </div>

                    </Col>
                    <Col lg={4}>
                        <div className="footerright">
                            <div className="footer-titltes mailing">
                                Mailing address
                            </div>
                            <div className="addresss">
                                C 206 ,Trendset Rythme,<br /> Serilingampally Mandal, Survey No.7, White Field Rd,<br /> Kondapur, Telangana 500084
                                <br></br>
                                {/* <span className="footercontact">Mail:</span>  contact@aimfoundation.ai */}
                            </div>
                        </div></Col>
                    <Col lg={4} className="footer-lastsection">
                        <div className="footerright">
                            <div className="footer-titltes mailing">
                                Links
                            </div>
                            <NavLink to="/media" className="footerlinks text-decoration-none">In Media</NavLink>
                            <NavLink to="/events" className="footerlinks text-decoration-none">Events</NavLink>

                            <div className="footerlinks" onClick={loginclick}>Contact Us</div>
                        </div>
                    </Col>
                </Row>
                <Row><div className="footerbottom">© Aimed Tech Alliance 2025</div></Row>
            </Container >
        </div>
    )
}
export default Footer;



